import { render, staticRenderFns } from "./IncentiveRedpacket.vue?vue&type=template&id=407ed596&scoped=true&"
import script from "./IncentiveRedpacket.vue?vue&type=script&lang=js&"
export * from "./IncentiveRedpacket.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "407ed596",
  null
  
)

export default component.exports